// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"flags_wrapper__33yYB","image":"flags_image__2ngwm"};